import { Icon, IconButton, LinearProgress, Stack, Switch } from "@mui/material";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import MDTypography from "components/MDTypography";
import { useLocation } from "react-router-dom";
import DeleteDialog from "components/UIComponents/DeleteDialog";
import { get } from "lodash";
import moment from "moment";
import { deleteSpace } from "store/slice/space/spaceSlice";
import { getSpaces } from "store/slice/space/spaceSlice";
import CircularIndeterminate from "components/MDLoading";
import CreateVipParking from "./CreateVipParking";
import { updateSpace } from "store/slice/space/spaceSlice";

const SlackTable = (props) => {
  const { slackData } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const [page, setPage] = useState(10);
  const [pageSize, setPageSize] = useState(10);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [spaceId, setSpaceId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedSpace, setSelectedSpace] = useState({});
  const [toggleLoading, setToggleLoading] = useState(null);

  const placesData = useSelector((state) => state.places?.selectedPlace);
  let placeId =
    placesData?._id || new URLSearchParams(location?.search).get("placeId");

  const handelDelete = () => {
    setIsLoading(true);
    dispatch(deleteSpace({ spaceId }))
      .unwrap()
      .then(async (res) => {
        if (res?.success) {
          dispatch(getSpaces(placeId));
          setDialogOpen(false);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("Error getting brand:", err);
      });
  };
  const handleUpdateSpace = (spaceId, type) => {
    setToggleLoading(spaceId);
    dispatch(updateSpace({ placeId, spaceId, type }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(getSpaces(placeId));
        }
      })
      .catch((err) => {
        console.error("Error space update:", err);
      })
      .finally(() => setToggleLoading(null));
  };

  const columnsData = [
    {
      field: "title",
      headerName: "Title",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.title}`}
        </MDTypography>
      ),
    },
    {
      field: "isPrimary",
      headerName: "Primary Space",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.isPrimary ? "Yes" : "No"}`}
        </MDTypography>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created On",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${moment(row.createdAt).format("MM/DD/YYYY")}`}
        </MDTypography>
      ),
    },
    {
      field: "Created By",
      headerName: "Created By",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${get(row, "userId.firstName", "")}  ${get(
            row,
            "userId.lastName",
            ""
          )}`}
        </MDTypography>
      ),
    },

    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: ({ row }) => (
        <>
          <Stack direction="row" alignItems="center">
            <Switch
              disabled={toggleLoading === row._id}
              checked={row?.status === 10}
              onChange={() =>
                handleUpdateSpace(
                  row?._id,
                  row?.status === 10 ? "INACTIVE" : "ACTIVE"
                )
              }
            />
            <IconButton
              onClick={() => {
                setEditDialogOpen(true);
                setSpaceId(row._id);
                setIsEdit(true);
                setSelectedSpace(row);
              }}
            >
              <Icon fontSize="small" title="Delete">
                edit
              </Icon>
            </IconButton>
            <IconButton
              color="error"
              onClick={() => {
                setDialogOpen(true);
                setSpaceId(row._id);
              }}
            >
              <Icon fontSize="small" title="Delete">
                delete
              </Icon>
            </IconButton>
          </Stack>
        </>
      ),
    },
  ];

  return (
    <>
      <MDDataGrid
        rows={slackData ?? []}
        columns={columnsData}
        getRowId={(row) => row._id}
        pagination
        page={page}
        pageSize={pageSize}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        disableSelectionOnClick={true}
        components={{
          NoRowsOverlay: EmptyTableRowOverlay,
          LoadingOverlay: LinearProgress,
        }}
      />
      <DeleteDialog
        dialogOpen={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        handelClick={handelDelete}
      />
      <CircularIndeterminate open={isLoading} text="Delete Space.. " />
      <CreateVipParking
        dialogOpen={editDialogOpen}
        onClose={() => {
          setIsEdit(false);
          setEditDialogOpen(false);
        }}
        isEdit={isEdit}
        data={selectedSpace}
      />
    </>
  );
};

export default SlackTable;
